import { format, isSameDay, isValid, parseISO, startOfDay } from 'date-fns';
import { ru } from 'date-fns/locale';

export function formatPmaFactDateTime(
  iso: string | null | undefined,
): string | null {
  if (!iso) {
    return null;
  }

  const date = parseISO(iso);
  if (!isValid(date)) {
    return null;
  }

  if (isSameDay(startOfDay(date), startOfDay(new Date()))) {
    return `сегодня, ${format(date, 'HH:mm')}`;
  }

  return format(date, 'dd MMM, HH:mm', { locale: ru });
}
